module.exports = __webpack_public_path__ + "static/media/97.becb40e5.png";